import { createContext, useContext, useState } from "react";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("adminToken") ?? "");

  const login  = (t) => { localStorage.setItem("adminToken", t); setToken(t); };
  const logout = ()  => { localStorage.removeItem("adminToken"); setToken(""); };

  return (
    <AuthCtx.Provider value={{ token, isAdmin: !!token, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
